<script>
    export let width = "100%";
    export let height = "1em";
</script>

<div 
    style={`width: ${width}; height: ${height}`}
    class="animate"/>

<style>
    .animate {
        animation : shimmer 2s infinite;
        background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
        background-size: 1000px 100%;
    }
    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }
</style>
